import { formatHotkey } from '../utils/useCommandActions';

type Props = {
  text: string;
  hotkey?: string;
}

// Row content for Actions dropdown items: label left, shortcut key flush right.
// Pair with popupSettings={{ popupClass: 'action-menu-popup' }} on the DropDownButton.
const ActionMenuItem = ({ text, hotkey }: Props) => {
  return <span className="d-flex justify-content-between align-items-center flex-grow-1">
    {text}
    {hotkey && <kbd className="ml-3 d-none d-lg-inline">{formatHotkey(hotkey)}</kbd>}
  </span>;
}

export default ActionMenuItem;
